import React, { useState, useRef } from 'react';
import { I18nextProvider } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import GenericIconButton from '../GenericComponents/GenericIconButton';
import styles from './MobileHomepage.module.css';
import { CCProvider, useCCContext } from '../CC/CCContext';
import * as ccUtils from '../CC/utils';
import MobileHomepageBlock from './MobileHomePageblock';

type MobileHomepageProps = {
    mainY: number;
    setMainY: React.Dispatch<React.SetStateAction<number>>;
};

const MobileHomepage: React.FC<MobileHomepageProps> = ({ mainY, setMainY }) => {
    const { t } = useTranslation();
    const { cc, setCc, first, setFirst, recordsPerPage, setRecordsPerPage, viewMode, setViewMode, browseMode, setBrowseMode, data, setData, isReady } = useCCContext();
    const topRef = useRef<HTMLDivElement | null>(null);
    const [isExpanded, setIsExpanded] = useState(false);

    const showMenu = () => {
        setMainY(0);
    }

    const showSearch = () => {
        setMainY(-200);
    }

    const introTextEnglish = 'Access the complete collections of objects and photography collections, nearly a million illustrated records, as well as descriptive catalogs of all collections of books, magazines, films, music, and archival collections.';
    const introTextFrench = 'Accédez à la totalité des collections d’objets et aux collections de photographies, soit près d’un million de notices illustrées, ainsi qu’aux catalogues descriptifs de toutes les collections de livres, revues, films, musiques et des fonds d’archives.';
    
    const expandedTextEnglish = 'These various collections are enriched and updated as acquisitions are made and research on the collections progresses: history, provenance, technical analyses, etc. Some records may contain sensitive content.\nThis new portal, still under development, provides access to more information than the previous one. It will be updated regularly to improve its functionality.';
    const expandedTextFrench = 'Ces différents ensembles sont enrichis et corrigés au fur et à mesure des acquisitions comme de l’avancée des travaux de recherche sur les collections : histoire, provenance, analyses techniques etc.\nCertaines notices peuvent comporter des contenus sensibles.\nCe nouveau portail, encore en cours de développement, donne accès à davantage d’informations que le précédent. Il sera mis à jour régulièrement pour en améliorer les fonctionnalités.';
    

    return (
        <div className={styles.MobileHomepage} >
            <div ref={topRef} className={styles.header}>
                <div className={styles.topLeftButton}>
                    <GenericIconButton
                        icon='regular/bars.svg'
                        hoverEnabled={true}
                        width='28px'
                        height='28px'
                        onClick={(e: any) => {
                            showMenu();
                        }}
                    />
                </div>
                <a href="https://www.quaibranly.fr/" className={styles.logo}></a>
            </div>
            <div className={styles.contents}>
                <div className={styles.intro}>
                    <div className={styles.introText}>
                        {i18n.language === 'en' ? introTextEnglish : i18n.language === 'fr' ? introTextFrench : ''}
                    </div>
                    {isExpanded ? (
                        <div className={isExpanded ? `${styles.isExpanded} ${styles.introAdditionalText}` : `${styles.introAdditionalText}`}>
                            {i18n.language === 'en' ? expandedTextEnglish : i18n.language === 'fr' ? expandedTextFrench : ''}
                        </div>
                    ) : null}
                    <div>
                        <a className={styles.introMoreButton} onClick={() => setIsExpanded(!isExpanded)}>
                            {isExpanded ? `- ${t("homepage_less")}` : `+ ${t("homepage_more")}`}
                        </a>
                    </div>
                    <div className={styles.introHyperlink} onClick={(e) => { showSearch() }}>{t("homepage_click_to_view")}</div>
                </div>
                <div className={styles.homepageBlocks}>
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Textile ou vêtement"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Objets/Images/118/118692.jpg&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_textile")}
                    />
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Arts graphiques"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Objets/Images/184/184559.jpg&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_arts")}
                    />
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Carte postale", "Affiche"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Icono/iconomedia/MQB-P-0002.11_01/PP0147888_01.JPG&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_affiche_et_carte")}
                    />
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Instrument de musique"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Objets/Images/135/135651.jpg&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_instruments")}
                    />
                </div>
                <div className={styles.homepageBlocks}>
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Peinture"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Objets/IDENTIFICATION_OBJETS/Photos_YMAGO/200000/207840y.jpg&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_peintures")}
                    />
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Photographie"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Icono/iconotheque/MQB-P-0005.41_01/PF0171035_01.jpg&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_photos")}
                    />
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Sculpture"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Objets/Images/186/186021.jpg&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_sculpture")}
                    />
                    <MobileHomepageBlock
                        onClick={(e) => {
                            e.preventDefault();
                            const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false, "facets": { "categorie": ["Objet archéologique"] } };
                            const newStateCc = ccUtils.convertStateToCC(newState);
                            setCc(newStateCc);
                            showSearch();
                        }}
                        imageUrl={"https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=Objets/Images/169/169194.jpg&width=180&height=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                        text={t("homepageblock_archeology")}
                    />
                </div>
            </div>

        </div>
    )
};

export default MobileHomepage;
